import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'curbnturf-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone: true,
  imports: [RouterModule],
})
export class AgritourismAppComponent {
  title = 'Agritourism Challenge Course';
}
